/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

/**
 * Svelte Action to make element a droparea (add drop/dragOver/dragOut events)
 * @example
 * <g
 *   use:setupDroparea={{ dropareaRegistry, areaKey, key: dropareaEnabled ? key : void 0 }}
 *   on:dragOver
     on:dragOut
     on:drop />
 * @param {HTMLElement} node - container node which acts as droparea
 * @param {Object} options
 * @param {Object} options.dropareaRegistry - dropAreaRegistryFactory object, shared among dragables and dropareas in the same drag group
 * @param {String} options.key - droparea identifier part 1 (if it's empty, droparea is disabled)
 * @param {String} options.areaKey - droparea identifier part 2 (optional)
 * @returns {Object} - node's lifecycle hooks
 */
export default function setupDroparea(node, { dropareaRegistry, key, areaKey }) {
    let actualKey = key;
    let actualAreaKey = areaKey || '';

    function register() {
        if (dropareaRegistry && actualKey) {
            dropareaRegistry.add(actualKey, actualAreaKey, node);
            node.setAttribute('data-droparea-key', actualKey);
            node.setAttribute('data-droparea-area', actualAreaKey);
        }
    }
    function unregister() {
        if (dropareaRegistry && actualKey) {
            node.removeAttribute('data-droparea-key');
            node.removeAttribute('data-droparea-area');
            dropareaRegistry.remove(node);
        }
    }

    register();

    return {
        update({ key: newKey, areaKey: newAreaKey }) {
            unregister();
            actualKey = newKey;
            actualAreaKey = newAreaKey;
            register();
        },
        destroy() {
            unregister();
        }
    };
}
